const file2formdata = files => {
    const formData = new FormData();
    for ( let file of files )
        formData.append( file.name, file );
    return formData;
};

export { file2formdata };
